import type { IconNode } from '../types';

/**
 * @name mop-sparkles
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJhMyAzIDAgMDEtMy0zIiAvPgogIDxwYXRoIGQ9Ik0xMCAyMmMyLjc2MSAwIDUtMS43OSA1LTQtNC40MiAwLTQuMDgtNS04LjUtNWE0LjUwMSA0LjUwMSAwIDAwMCA5eiIgLz4KICA8cGF0aCBkPSJNMTAgM0g4IiAvPgogIDxwYXRoIGQ9Ik0xMi41IDExLjUgMjIgMiIgLz4KICA8cGF0aCBkPSJNMjAgMTN2NCIgLz4KICA8cGF0aCBkPSJNMjIgMTVoLTQiIC8+CiAgPHBhdGggZD0iTTQgNXY0IiAvPgogIDxwYXRoIGQ9Ik02IDdIMiIgLz4KICA8cGF0aCBkPSJtNi45OCAxMy4wMiAyLjY2NS0yLjY2NGExLjIxIDEuMjEgMCAwMTEuNzEgMGwyLjI5IDIuMjg4YTEuMjEgMS4yMSAwIDAxMCAxLjcxMmwtMi4wODggMi4wODciIC8+CiAgPHBhdGggZD0iTTkgMnYyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mop-sparkles
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MopSparkles: IconNode = [
  ['path', { d: 'M10 22a3 3 0 01-3-3' }],
  ['path', { d: 'M10 22c2.761 0 5-1.79 5-4-4.42 0-4.08-5-8.5-5a4.501 4.501 0 000 9z' }],
  ['path', { d: 'M10 3H8' }],
  ['path', { d: 'M12.5 11.5 22 2' }],
  ['path', { d: 'M20 13v4' }],
  ['path', { d: 'M22 15h-4' }],
  ['path', { d: 'M4 5v4' }],
  ['path', { d: 'M6 7H2' }],
  [
    'path',
    {
      d: 'm6.98 13.02 2.665-2.664a1.21 1.21 0 011.71 0l2.29 2.288a1.21 1.21 0 010 1.712l-2.088 2.087',
    },
  ],
  ['path', { d: 'M9 2v2' }],
];

export default MopSparkles;
